import DashboardTypes from './DashboardTypes';

export const getOpenBidsInProgress = (payload) => {
  return {
    type: DashboardTypes.GET_OPEN_BIDS_PROGRESS,
    payload,
  };
};

export const getOpenBidsInSuccess = (payload) => {
  return {
    type: DashboardTypes.GET_OPEN_BIDS_SUCCESS,
    payload,
  };
};

export const getOpenBidsInError = (payload) => {
  return {
    type: DashboardTypes.GET_OPEN_BIDS_ERROR,
    payload,
  };
};

export const getLastSevenDaysDataInProgress = (payload) => {
  return {
    type: DashboardTypes.GET_LAST_SEVEN_DAYS_DATA_PROGRESS,
    payload,
  };
};

export const getLastSevenDaysDataInSuccess = (payload) => {
  return {
    type: DashboardTypes.GET_LAST_SEVEN_DAYS_DATA_SUCCESS,
    payload,
  };
};

export const getLastSevenDaysDataInError = (payload) => {
  return {
    type: DashboardTypes.GET_LAST_SEVEN_DAYS_DATA_ERROR,
    payload,
  };
};

export const getAwardedBidsInProgress = (payload) => {
  return {
    type: DashboardTypes.GET_AWARDED_BIDS_PROGRESS,
    payload,
  };
};

export const getAwardedBidsInSuccess = (payload) => {
  return {
    type: DashboardTypes.GET_AWARDED_BIDS_SUCCESS,
    payload,
  };
};

export const getAwardedBidsInError = (payload) => {
  return {
    type: DashboardTypes.GET_AWARDED_BIDS_ERROR,
    payload,
  };
};

export const getOpenBidsAgingInProgress = (payload) => {
  return {
    type: DashboardTypes.GET_OPEN_AGING_PROGRESS,
    payload,
  };
};

export const getOpenBidsAgingInSuccess = (payload) => {
  return {
    type: DashboardTypes.GET_OPEN_AGING_SUCCESS,
    payload,
  };
};

export const getOpenBidsAgingInError = (payload) => {
  return {
    type: DashboardTypes.GET_OPEN_AGING_ERROR,
    payload,
  };
};

export const getOverallTimeLineInProgress = (payload) => {
  return {
    type: DashboardTypes.GET_OVERALL_TIMELINE_PROGRESS,
    payload,
  };
};

export const getOverallTimeLineInSuccess = (payload) => {
  return {
    type: DashboardTypes.GET_OVERALL_TIMELINE_SUCCESS,
    payload,
  };
};

export const getOverallTimeLineInError = (payload) => {
  return {
    type: DashboardTypes.GET_OVERALL_TIMELINE_ERROR,
    payload,
  };
};
